var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Loading } from 'element-ui';
import { Component, Watch } from 'vue-property-decorator';
import moment from 'moment';
import _ from 'lodash';
import { mapGetters, mapActions } from "vuex";
import { UrlHelper } from "../../helper/UrlWrapper";
import Pagination from "../../common/components/Pagination.vue";
import SectionMenu from './SectionMenu.vue';
import DataChart from '../echarts/DataChart.vue';
import DataChartGoodClass from '../echarts/DataChartGoodClass.vue';
import { indexApplyOrderDate } from "../../helper/defaultDate";
import HomeService from '../../api/HomeService';
import CommonService from '../../api/CommonService';
import GoodService from '../../api/GoodService';
var initFormData = {
    dimension: 1,
    shop_id: [],
    time_type: 1,
    goods_type_ids: [],
    goods_ids: [],
    route_id: 0
};
function getDefaultFormData() {
    return {
        shop_ids: null,
        transaction_status: 3,
        s_time: indexApplyOrderDate().Start.format('yyyy-MM-dd'),
        e_time: indexApplyOrderDate().End.format('yyyy-MM-dd'),
        route_id: 0,
    };
}
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = {};
        _this.formData = _.cloneDeep(initFormData);
        _this.shopList = [];
        _this.allClientIds = [];
        _this.categoryData = [];
        _this.goodData = [];
        _this.dimensionOptions = [
            { id: 1, label: '按客户' },
            { id: 2, label: '按货品' },
        ];
        _this.purchaseTopData = [];
        _this.times = 0;
        _this.subOpens = [];
        _this.prefix = "MENU_";
        _this.defaultActive = _this.prefix + "1";
        _this.applyOrderDialog = false;
        _this.applyOrderData = [];
        _this.applyFormData = getDefaultFormData();
        _this.organBusiness = [];
        _this.transactionList = [
            {
                id: "",
                name: "全部"
            },
            {
                id: 1,
                name: "已交易"
            },
            {
                id: 2,
                name: "交易中"
            },
            {
                id: 3,
                name: "未交易"
            },
        ];
        _this.routes = [
            {
                route_id: 0,
                route_name: "全部路线"
            }
        ];
        _this.total = 0;
        return _this;
    }
    default_1.prototype.normalizerShop = function (node) {
        return {
            id: node.supplier_to_business_id,
            label: node.name,
            children: node.children,
        };
    };
    default_1.prototype.normalizerGoodType = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    ;
    default_1.prototype.watchFormDataDimension = function (newVal, oldVal) {
        this.formData = __assign({}, initFormData, { dimension: newVal, time_type: this.formData.time_type });
        if (newVal === 2 && !this.categoryData.length)
            this.getCategory();
    };
    default_1.prototype.watchFormDataGoodTypeId = function (newVal, oldVal) {
        if (newVal) {
            if (newVal.length) {
                this.getGood();
            }
            else {
                this.goodData = [];
            }
        }
    };
    default_1.prototype.created = function () {
        this.service = HomeService.getInstance();
        this.commonService = CommonService.getInstance();
        this.goodService = GoodService.getInstance();
        this.getSalesAnalyze();
        this.getCustomer();
        this.getPurchaseTop();
        this.getOrganDepot({ freeze: 0 });
        this.getRouteList();
    };
    default_1.prototype.search = function () {
        this.getSalesAnalyze();
    };
    default_1.prototype.getRouteList = function () {
        var _this = this;
        this.service.getRouteList({}).then(function (res) {
            if (res.data.success) {
                _this.routes = _this.routes.concat(res.data.data);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getOrganDepot = function (params) {
        var _this = this;
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = Array.isArray(res.data.data) ? res.data.data : [];
                _this.organBusiness = depot;
                console.log(_this.organBusiness);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.changeTransactionStatus = function () {
        this.$refs.pagination.clear();
    };
    default_1.prototype.dateChange = function () {
        this.$refs.pagination.clear();
    };
    default_1.prototype.shopSelect = function (node) {
        this.applyFormData.shop_ids = node.shop_contact;
        this.$refs.pagination.clear();
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    default_1.prototype.getPurchaseTop = function () {
        var _this = this;
        this.service.getPurchaseTop().then(function (res) {
            _this.purchaseTopData = Array.isArray(res.data.data) ? res.data.data : [];
            if (_this.purchaseTopData.length) {
                _this.purchaseTopData.forEach(function (item) {
                    if (item.shop_name && item.shop_name.length > 19) {
                        item.shop_name = item.shop_name.substring(0, 19) + "...";
                    }
                });
            }
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.resetApplyOrderData = function () {
        this.applyFormData = getDefaultFormData();
    };
    default_1.prototype.searchApplyData = function () {
        this.getApplyOrderData();
    };
    default_1.prototype.exportApplyData = function () {
        this.exportApplyOrderData();
    };
    default_1.prototype.exportApplyOrderData = function () {
        var url = "supplierclientapi/home/shop_purchase_status_export?token=" + this.user.token;
        if (this.applyFormData.shop_ids) {
            url = UrlHelper.addParam(url, "shop_ids", this.applyFormData.shop_ids.join(","));
        }
        url = UrlHelper.addParam(url, "transaction_status", this.applyFormData.transaction_status);
        url = UrlHelper.addParam(url, "s_time", this.applyFormData.s_time);
        url = UrlHelper.addParam(url, "e_time", this.applyFormData.e_time);
        url = UrlHelper.addParam(url, "route_id", this.applyFormData.route_id);
        location.href = url;
        window._czc.push(["_trackEvent", '送货单导出', '送货单导出']);
    };
    default_1.prototype.pageChange = function () {
        this.getApplyOrderData();
    };
    default_1.prototype.getApplyOrderData = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        console.log(this.$refs);
        var pager = this.$refs.pagination ? this.$refs.pagination.getPage() : {
            page: 1,
            start: 0,
            limit: 10
        };
        this.service.getApplyOrderData(Object.assign(this.applyFormData, pager)).then(function (res) {
            _this.applyOrderData = Array.isArray(res.data.data) ? res.data.data : [];
            _this.total = res.data.total;
            _this.applyOrderDialog = true;
            loadingInstance.close();
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.applyOrderDialogShow = function () {
        var _this = this;
        this.applyOrderDialog = false;
        this.$nextTick(function () {
            _this.applyOrderDialog = true;
        });
        this.resetApplyOrderData();
        this.getApplyOrderData();
    };
    default_1.prototype.closeTab = function () {
        var closeBtnArr = $(".navTabsCloseBtn").prev();
        for (var i = 0; i < closeBtnArr.length; i++) {
            if ($(closeBtnArr[i])[0].innerText == "销售汇总") {
                console.log($(closeBtnArr[i]).next());
                $(closeBtnArr[i]).next().click();
            }
        }
    };
    default_1.prototype.toSalesSummary = function () {
        this.closeTab();
        localStorage.setItem("ToSalesSummary", "1");
        this.$emit("to-detail");
    };
    default_1.prototype.getSalesAnalyze = function () {
        var _this = this;
        var params = {
            dimension: this.formData.dimension,
            time_type: this.formData.time_type,
        };
        if (this.formData.dimension === 1) {
            var supplier_to_business_ids_1 = [];
            var shop_ids_1 = [];
            this.formData.shop_id.map(function (item) {
                if (_this.allClientIds.includes(item)) {
                    supplier_to_business_ids_1.push(item);
                }
                else {
                    shop_ids_1.push(item);
                }
            });
            params.supplier_to_business_ids = supplier_to_business_ids_1.join(',');
            params.shop_ids = shop_ids_1.join(',');
        }
        else {
            params.goods_type_ids = this.formData.goods_type_ids.join(',');
            params.goods_ids = this.formData.goods_ids.join(',');
        }
        this.service
            .getSalesAnalyze(params)
            .then(function (res) {
            var DATA = res.data || {};
            _this.data = DATA.data || {};
            console.log('this.data', _this.data);
            _this.chartConfig();
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.chartConfig = function () {
        var _this = this;
        var startDateValue = moment().subtract(6, 'days').valueOf();
        var endDateValue = moment().valueOf();
        if (this.formData.time_type === 2) {
            startDateValue = moment().subtract(29, 'days').valueOf();
        }
        var dateStep = 24 * 60 * 60 * 1000;
        var lineXAxis = [];
        for (var i = startDateValue; i <= endDateValue; i = i + dateStep) {
            var formatDate = moment(i).format('M[月]D[日]');
            lineXAxis.push(formatDate);
        }
        var lineSeries = [
            {
                name: '销售',
                type: 'line',
                data: this.data.date_summary.sale_moneys,
            },
            {
                name: '退货',
                type: 'line',
                data: this.data.date_summary.refund_moneys,
            },
            {
                name: '销售-退货',
                type: 'line',
                data: this.data.date_summary.order_moneys,
            },
            {
                name: '平均采购额',
                type: 'line',
                markLine: {
                    symbol: "none",
                    data: [{
                            silent: false,
                            yAxis: this.data.date_summary.sale_money_average,
                        }],
                },
            },
        ];
        var pieSeries = {
            type: 'pie',
            radius: '50%',
            label: {
                normal: {
                    show: true,
                    textStyle: {
                        fontSize: 14,
                    },
                    formatter: '{d}%',
                },
            },
            data: [],
        };
        this.data.type_summary.moneys.map(function (item, index) {
            pieSeries.data.push({
                name: _this.data.type_summary.names[index],
                value: item,
            });
        });
        this.$nextTick(function () {
            _this.$refs.LineChart && _this.$refs.LineChart.initChart(lineXAxis, lineSeries);
            _this.$refs.PieChart && _this.$refs.PieChart.initChart('', pieSeries);
        });
    };
    default_1.prototype.getCustomer = function () {
        var _this = this;
        this.commonService
            .getShop({
            real: 1,
        })
            .then(function (res) {
            var DATA = res.data || {};
            _this.shopList = Array.isArray(DATA.data) ? DATA.data : [];
            _this.allClientIds = _this.shopList.map(function (item) { return item.supplier_to_business_id; });
        });
    };
    default_1.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory({ level: 4 }).then(function (res) {
            var DATA = res.data || {};
            _this.categoryData = Array.isArray(DATA.data) ? DATA.data : [];
        });
    };
    default_1.prototype.getGood = function () {
        var _this = this;
        this.commonService
            .getGoodslist({
            goods_type: this.formData.goods_type_ids.join(','),
            dimension: 1,
        })
            .then(function (res) {
            var DATA = res.data || {};
            var goodData = Array.isArray(DATA.data) ? DATA.data : [];
            _this.goodData = [{ goods_id: '', goods_name: '全部' }].concat(goodData);
        });
    };
    __decorate([
        Watch('formData.dimension')
    ], default_1.prototype, "watchFormDataDimension", null);
    __decorate([
        Watch('formData.goods_type_ids')
    ], default_1.prototype, "watchFormDataGoodTypeId", null);
    default_1 = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"])),
            components: {
                SectionMenu: SectionMenu,
                DataChart: DataChart,
                DataChartGoodClass: DataChartGoodClass,
                'pagination': Pagination,
            },
            computed: __assign({}, mapGetters({
                "user": "user",
                serviceData: 'serviceData'
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
